import { useEffect, useState } from "react";
import { format } from "date-fns";

import {DATE_FNS_LOCALES,getCurrentLanguage } from "../../i18n/languageService";
import { DEFAULT_LANGUAGE } from "../../i18n/languages";


export const useLocalizedDate = (dateInput = new Date(), formatPattern = "PPpp") => {

  const [currentLang, setCurrentLang] = useState(getCurrentLanguage());
  const currentLocale = DATE_FNS_LOCALES[currentLang] || DATE_FNS_LOCALES[DEFAULT_LANGUAGE];

  useEffect(() => {
  const onLangChange = (event) => {
    setCurrentLang(event.detail || getCurrentLanguage());
  };

  window.addEventListener("app-language-changed", onLangChange);

  return () => {
    window.removeEventListener("app-language-changed", onLangChange);
  };
}, []);

  const safeDate =
    dateInput instanceof Date ? dateInput : new Date(dateInput);

  const formatted = format(safeDate, formatPattern, {
    locale: currentLocale,
  });

  return {
    rawDate: safeDate,
    formatted,
    currentLang,
    currentLocale,
  };
};
